import { columnName, tableName } from 'app/area/case/case-data-model';
import { entityValue } from 'app/infrastructure/store/entity';
import { Entity } from 'app/types-shared';

export const connectedCasesSortValue = () => 
  ({ sortValue: (c: Entity) => Number(entityValue(c, columnName[tableName.connectedCases].connectedSequence)) });
